import { postAPI } from "./postAPI";
import { getAPI } from "./getAPI";
import { downloadAPI } from "./downloadAPI";
import { deleteAPI } from "./deleteAPI";
import { patchAPI } from "./patchAPI";
import { fileAPI } from "./fileAPI";

export const postAPICall = postAPI;
export const getAPICall = getAPI;
export const deleteAPICall = deleteAPI;
export const patchAPICall = patchAPI;
export const fileAPICall = fileAPI;
export const downloadAPICall = downloadAPI;